import React, { Component } from 'react';
import Alert from '@mui/material/Alert';

type AlertInfoProps = {
    message: string,
}

function AlertInfo({ message }: AlertInfoProps) {
    if (message.length == 0) {
        return (<div></div>);
    }

    return (
        <Alert severity="info">
            {message}
        </Alert>
    );
}

export { 
    AlertInfo
}